import moment from 'moment-jalaali';

/** ZRE (Khayyām) era year for Magian display: Gregorian year + 1738 (same as Calendar Magian header). */
export const zreYearFromGregorian = (date: moment.Moment = moment()) => date.year() + 1738;
